<template>
	<div class="learner_program_data">

		<div class="row">
      <div class="col-12">
        <template v-if="careerGoal">
          <b-card class="text-center prog-lmi ace_sec" :aria-label="careerGoal.name">

						<template #header>
        			<div class="hd_txt">
								<v-clamp class="" autoresize :max-lines="2"> Programs for your Career </v-clamp>
							</div>
      			</template>

						<div class="crd_content">

							<b-card-text>
	              <div class="row sec_row" v-for="major in careerGoal.majors">
	                <div class="col-6 label">
                      <div class="hd_ic">
      								<img v-if="major.thumbnailURL" :src="major.thumbnailURL" :alt="major.title + ' Thumbnail'">
      							</div>
                  </div>
	                <div class="col-6 val ace_sec_txt">
	                  {{major.title}}
	                </div>
	              </div>
	            </b-card-text>

						</div>

						<div class="lnk_container">
							<a tabindex="0" href="javascript://" @click="navigateToCareerPathways">Learning Pathways</a>
						</div>

          </b-card>
        </template>
        <template v-else>
          <b-card class="text-center prog-lmi ace_sec" aria-label="Career LMI data not available">

						<template #header>
							<div class="hd_ic">

							</div>
							<div class="hd_txt">

							</div>
						</template>

						<div class="crd_content">
	            <b-card-text>
	              <div class="mt-5">
	                <span>Career LMI data not available.</span>
	              </div>
	            </b-card-text>
						</div>

          </b-card>
        </template>
      </div>
    </div>

	</div>
</template>

<script>
	import { mapActions } from 'vuex'
	import { StorageFactory } from '../../../storageFactory'
	import VClamp from 'vue-clamp'

  export const localStore = StorageFactory(() => localStorage)

	export default {
		name: 'learner-career-pathways',
		components: {
			VClamp
		},
    props: ['careerGoal'],
		methods: {
			addCommaInNumber (numValue) {
        return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
      navigateToCareerPathways () {
        let routerParams = {
          code: this.careerGoal.pragyaSoc,
          returnTo: 'learnerDashboard',
          showBackToResultButton: true
        }
        return this.$router.push({name: 'careerPrograms', params: routerParams, query: {returnTo: 'learnerDashboard'}})
      }
		}
	}
</script>

<style scoped>
  .prog-lmi .card-header {
    height: 65px;
  }
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/LearnerCareerPathways.vue